/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Efforts_Precise_Threshold_PaceInputs */

const en_ui_laps_efforts_precise_threshold_pace = /** @type {(inputs: Ui_Laps_Efforts_Precise_Threshold_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add threshold pace for precise efforts`)
};

const de_ui_laps_efforts_precise_threshold_pace = /** @type {(inputs: Ui_Laps_Efforts_Precise_Threshold_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwellentempo eintragen für genaue Belastungen`)
};

/**
* | output |
* | --- |
* | "Add threshold pace for precise efforts" |
*
* @param {Ui_Laps_Efforts_Precise_Threshold_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_efforts_precise_threshold_pace = /** @type {((inputs?: Ui_Laps_Efforts_Precise_Threshold_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Efforts_Precise_Threshold_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_efforts_precise_threshold_pace(inputs)
	return de_ui_laps_efforts_precise_threshold_pace(inputs)
});